import gql from "graphql-tag";

/**
 * Mutation used by nimasa agents to process shipping requests.
 */
const ApproveOrDisapproveShippingRequest = gql`
  mutation(
    $shipping_request_id: String!
    $type: ShippingRequestProcessingType!
    $rejection_message: String
  ) {
    ApproveOrDisapproveShippingRequest(
      shipping_request_id: $shipping_request_id
      type: $type
      rejection_message: $rejection_message
    ) {
      id
      status
    }
  }
`;

export default ApproveOrDisapproveShippingRequest;
